import {useMailActions} from "@twigsby/client-data";
import {GetArrayIndexByKeyValue} from "@twigsby/helpers";
import {useState} from "react";

const useMailItemActions = () => {
    const { data, status: mailItemActionsStatus, error: mailItemActionsError } = useMailActions();

    const [ selectionActions, setSelectionActions] = useState<any>(null);

    const FilterActions = (mailData: any, selected: Array<any>) => {
        if(!mailData || !data || !data?.data || data?.data?.length < 1 || !selected || selected.length < 1) {
            setSelectionActions(null);
            return;
        }

        let selectedData = mailData.pages ? mailData.pages.map((group: any) => group.data.filter((mailItem: any) => selected.includes(mailItem.mailUuid) ? mailItem : null ))[0] : mailData;
        let newActions: Array<any> = [];
        let exclude: Array<string> = [];

        for (let i = 0; i < selectedData.length; i++) {
            if(data?.data && selectedData[i].actions?.length === 0) {
                data?.data.forEach((item) => exclude.push(item.name));
            }

            for (let j = 0; j < selectedData[i].actions?.length; j++) {
                if(data?.data) {
                    newActions = [...data?.data];
                    for (let k = 0; k < newActions.length; k++) {
                        const newEntry = GetArrayIndexByKeyValue(selectedData[i].actions, 'name', newActions[k].name);

                        if (newEntry === -1 && !exclude.includes(newActions[k].name)) {
                            exclude.push(newActions[k].name);
                        }
                    }
                }
            }
        }

        if(exclude.length > 0) {
            let exclusions = exclude.filter((v, i, a) => a.indexOf(v) === i);

            for (let m = newActions.length - 1; m >= 0; m--) {
                if(exclusions.includes(newActions[m].name)) {
                    newActions.splice(m, 1);
                }
            }
        }

        setSelectionActions(newActions);
    };

    return { mailItemActionsError, mailItemActionsStatus, selectionActions, FilterActions }
}

export default useMailItemActions
